import { VehicleType, FuelType, } from '../generated/onegraph';
export function extractConsumptionAndEmissionValues(consumptionAndEmissionSummary, vehicleType) {
    if (!consumptionAndEmissionSummary || !vehicleType)
        return null;
    let powerConsumption;
    let consumption;
    let emissionSummary;
    let fuelConsumptionBatteryDischarged = '';
    let classBatteryDischarged = '';
    const { eecsSummary, consumptionsSummary, emissionsCO2Summary } = consumptionAndEmissionSummary;
    if (isNotDefined(consumptionsSummary))
        throw new Error('no consumptionSummary');
    if (isNotDefined(emissionsCO2Summary))
        throw new Error('no emissionSummary');
    if (vehicleType === VehicleType.Bev) {
        const electricCons = consumptionsSummary?.find((con) => con.fuelType === FuelType.Electrical);
        powerConsumption = electricCons?.values?.[0]?.formattedValue;
    }
    else if (vehicleType === VehicleType.Icev) {
        const fuelCons = consumptionsSummary?.find(({ fuelType }) => fuelType && isICEfuelType(fuelType));
        consumption = fuelCons?.values?.[0]?.formattedValue || '';
    }
    else {
        const electricCons = consumptionsSummary?.find((con) => con.fuelType === FuelType.Electrical);
        powerConsumption = electricCons?.values?.[0]?.formattedValue || '';
        emissionSummary = emissionsCO2Summary?.find((con) => con.values !== null)?.values?.[0]
            ?.formattedValue;
        const fuelCons = consumptionsSummary?.find(({ fuelType }) => fuelType && isICEfuelType(fuelType));
        fuelConsumptionBatteryDischarged = fuelCons?.values?.[0]?.formattedValue || '';
        consumption = fuelCons?.values?.[1]?.formattedValue || '';
        classBatteryDischarged = eecsSummary?.[1]?.formattedValue || '';
    }
    const classFb = eecsSummary?.[0]?.formattedValue || '';
    if (!emissionSummary) {
        emissionSummary = emissionsCO2Summary?.[0]?.values?.[0]?.formattedValue;
    }
    return {
        consumption: `${consumption || ''}${consumption && powerConsumption ? '; ' : ''}${powerConsumption || ''}`,
        emissionCO2: emissionSummary,
        co2Class: classFb,
        dischargedConsumption: fuelConsumptionBatteryDischarged,
        dischargedCO2Class: classBatteryDischarged,
    };
}
const isNotDefined = (input) => {
    if (input === undefined)
        return true;
    if (input === null)
        return true;
    return false;
};
function isICEfuelType(fuelType) {
    return Boolean(fuelType === FuelType.Petrol || fuelType === FuelType.Diesel || fuelType === FuelType.Cng);
}
export function basePrNumbersToItems(basePrNumbers) {
    return basePrNumbers ? basePrNumbers.split(',') : [];
}
function isConfiguredCar(car) {
    return car?.__typename === 'ConfiguredCar';
}
export function getCaeDataForCarByCode(query) {
    if (!query)
        return null;
    const { carByCode } = query;
    const isConfigured = isConfiguredCar(carByCode);
    if (isConfigured) {
        const audicodeSummary = carByCode.technicalData?.consumptionAndEmission?.summary;
        const vehicleType = carByCode.carlineStructureCarline?.vehicleType;
        const caeData = extractConsumptionAndEmissionValues(audicodeSummary, vehicleType);
        return caeData;
    }
    return null;
}
//# sourceMappingURL=CaeUtils.js.map